import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultIconSetting,
  defaultComplexFontSetting,
  defaultSimpleFontSetting,
  defaultSizeSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "enableExpand",
    desc: "允许收起锚点",
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "showExpandText",
    desc: "显示文字",
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "expandInnerText",
    desc: "内容",
    type: "inputSet",
    defaultValue: ''
  },
  {
    name: "expandInnerTips",
    desc: "提示",
    type: "inputSet",
    defaultValue: ''
  },
  {
    name: "expandText",
    desc: "文字",
    type: "simpleFontSet",
    defaultValue: {
      ...defaultSimpleFontSetting,
      colorMode: 'complex'
    }
  },
  {
    name: "expandTextAlign",
    desc: "对齐",
    type: "sliderSet",
    defaultValue: "center",
    extraConfig: {
      showToolTip: true,
      useType: "horizontalTextAlign",
      titleStyle: {
        width: "52px"
      }
    }
  },
  {
    name: "expandTextMode",
    desc: "方向",
    type: "sliderSet",
    defaultValue: "horizontal-tb",
    extraConfig: {
      showToolTip: true,
      useType: "writingMode",
      titleStyle: {
        width: "52px"
      }
    }
  },
  {
    name: 'expandTextLineHeight',
    desc: "行高",
    type: "numberSet",
    defaultValue: 16,
    unit: "px",
    extraConfig: {
      styleId: 2,
      suffix: 'px'
    }
  },
  {
    name: 'expandTextLetterSpacing',
    desc: "字间距",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      styleId: 2,
      suffix: 'px'
    }
  },
  {
    name: "expandTextHover",
    desc: "文字",
    type: "simpleFontSet",
    defaultValue: {
      ...defaultSimpleFontSetting,
      colorMode: 'complex'
    }
  },
  {
    name: "expandSize",
    desc: "尺寸",
    type: "sizeSet",
    defaultValue: {
      ...defaultSizeSetting
    },
    extraConfig: {
      noFull: true
    }
  },
  {
    name: "expandIcon",
    desc: "图标",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting
    }
  },
  {
    name: "expandIconHover",
    desc: "图标",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting
    }
  },
  {
    name: "expandBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "expandBackgroundHover",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "expandBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting
    }
  },
  {
    name: "showExpandBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "expandBorderHover",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting
    }
  },
  {
    name: "enableBackPosition",
    desc: "开启定位",
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "backDis",
    desc: "偏移",
    type: "numberSet",
    defaultValue: 0
  },
  {
    name: "expandRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "expandRadiusHover",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "expandOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "expandOpacityHover",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "expandShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "expandShadowHover",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  }
]

export const menuSetting = [
  "enableExpand",
  {
    type: "status",
    enable(config) {
      return config.enableExpand
    },
    statusSettings: [
      {
        title: "默认",
        settings: [
          {
            type: "collapse",
            title: "文字",
            settings: [
              "showExpandText",
              {
                type: "block",
                enable(config) {
                  return config.showExpandText
                },
                settings: ["expandText", "expandTextAlign", "expandTextLineHeight", "expandTextMode", "expandTextLetterSpacing"]
              },"expandInnerText", "expandInnerTips"
            ]
          },
          {
            type: "collapse",
            title: "尺寸",
            settings: ["expandSize"]
          },
          {
            type: "collapse",
            title: "图标",
            settings: ["expandIcon"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["expandBackground"]
          },
          {
            type: "collapse",
            title: "边框",
            settings: [
              "showExpandBorder",
              {
                type: "basic",
                name: "expandBorder",
                enable(config) {
                  return config.showExpandBorder
                }
              },
              "expandRadius"
            ]
          },
          {
            type: "collapse",
            title: "位置",
            settings: [
              "enableBackPosition",
              {
                type: "basic",
                name: "backDis",
                enable(config) {
                  return config.enableBackPosition
                }
              }
            ]
          },
          {
            type: "collapse",
            title: "更多",
            settings: ["expandOpacity", "expandShadow"]
          }
        ]
      },
      {
        title: "悬停",
        settings: [
          {
            type: "collapse",
            title: "文字",
            settings: ["expandTextHover"]
          },
          {
            type: "collapse",
            title: "图标",
            settings: ["expandIconHover"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["expandBackgroundHover"]
          },
          {
            type: "collapse",
            title: "边框",
            settings: ["expandBorderHover", "expandRadiusHover"]
          },
          {
            type: "collapse",
            title: "更多",
            settings: ["expandOpacityHover", "expandShadowHover"]
          }
        ]
      }
    ]
  }
]
